import { CountryCodes } from '@/enums/general'

export const returnReasons = Object.freeze({
  1: 'Stitching',
  2: 'Hole',
  3: 'Size',
  4: 'Design',
  6: 'TooSmall',
  7: 'TooBig',
  5: 'Other'
})

export const OrderStatuses = Object.freeze({
  openPayment: 0,
  paymentCompleted: -1,
  shipmentCreated: 3,
  delivered: 4,
  returnOrder: 5,
  returnOrderApproved: 6,
  returnRequestCompleted: 7,
  waste: 66
})

export const DevCampaignIds = Object.freeze({
  friendCampaign: 40
})

export const ProdCampaignIds = Object.freeze({
  friendCampaign: 52
})

export const OrderTypes = Object.freeze({
  freeTrial: 0,
  membership: 1,
  intranet: 2,
  promo: 3,
  return: 4,
  loyalty: 6
})

export const MonthlyOrderDeliveryDate = Object.freeze({
  [CountryCodes.austria]: {
    earliest: 17,
    latest: 23,
    exact: 20
  },
  [CountryCodes.belgium]: {
    earliest: 17,
    latest: 23,
    exact: 20
  },
  [CountryCodes.denmark]: {
    earliest: 17,
    latest: 23,
    exact: 20
  },
  [CountryCodes.germany]: {
    earliest: 17,
    latest: 23,
    exact: 20
  },
  [CountryCodes.spain]: {
    earliest: 17,
    latest: 23,
    exact: 20
  },
  [CountryCodes.france]: {
    earliest: 17,
    latest: 23,
    exact: 20
  },
  [CountryCodes.netherlands]: {
    earliest: 17,
    latest: 23,
    exact: 20
  },
  [CountryCodes.unitedKingdom]: {
    earliest: 17,
    latest: 23,
    exact: 20
  },
  [CountryCodes.sweden]: {
    earliest: 17,
    latest: 23,
    exact: 20
  },
  [CountryCodes.italy]: {
    earliest: 17,
    latest: 23,
    exact: 20
  },
  [CountryCodes.poland]: {
    earliest: 17,
    latest: 23,
    exact: 20
  },
  [CountryCodes.switzerland]: {
    earliest: 17,
    latest: 23,
    exact: 20
  },
  [CountryCodes.ireland]: {
    earliest: 17,
    latest: 23,
    exact: 20
  },
  [CountryCodes.luxembourg]: {
    earliest: 17,
    latest: 23,
    exact: 20
  },
  [CountryCodes.portugal]: {
    earliest: 17,
    latest: 23,
    exact: 20
  },
  [CountryCodes.finland]: {
    earliest: 17,
    latest: 23,
    exact: 20
  },
  [CountryCodes.norway]: {
    earliest: 17,
    latest: 23,
    exact: 20
  },
  [CountryCodes.czechRepublic]: {
    earliest: 17,
    latest: 23,
    exact: 20
  }
})

// On this day of the month you will still take part of this months order creation
// One day later it will be the next months order
export const LastOrderCreationDates = Object.freeze({
  [CountryCodes.austria]: 24,
  [CountryCodes.belgium]: 19,
  [CountryCodes.denmark]: 25,
  [CountryCodes.germany]: 24,
  [CountryCodes.spain]: 25,
  [CountryCodes.france]: 25,
  [CountryCodes.netherlands]: 19,
  [CountryCodes.unitedKingdom]: 25,
  [CountryCodes.sweden]: 25,
  [CountryCodes.italy]: 25,
  [CountryCodes.poland]: 25,
  [CountryCodes.switzerland]: 25,
  [CountryCodes.ireland]: 25,
  [CountryCodes.luxembourg]: 24,
  [CountryCodes.portugal]: 25,
  [CountryCodes.finland]: 25,
  [CountryCodes.norway]: 25,
  [CountryCodes.czechRepublic]: 25
})
